import { Component, OnInit, signal } from '@angular/core';
import { trigger, style, animate, transition, stagger, query } from '@angular/animations';

import { LoaderGlobeAnimationDetailComponent, WindowService } from '@frontend/common';
import { Subscription } from 'rxjs';
import { RouterModule } from '@angular/router';
import { TranslocoModule } from '@jsverse/transloco';

interface Avatar {
  id: number;
  imageUrl: string;
  name: string;
}

@Component({
  selector: 'interculturalist-home',
  templateUrl: './home.component.html',
  styleUrls: ['./home.component.scss'],
  animations: [
    trigger('avatarListAnimation', [
      transition(':enter', [
        query('.avatar', [
          style({ opacity: 0, transform: 'scale(0.8)' }),
          stagger(50, [
            animate('300ms ease-out', style({ opacity: 1, transform: 'scale(1)' }))
          ])
        ], { optional: true }) // Prevents errors if no .avatar elements are found
      ])
    ])
  ],

   imports: [
    RouterModule,
    TranslocoModule,
    LoaderGlobeAnimationDetailComponent,
  ]
})
export class HomeComponent implements OnInit {
  
  subscriptions = signal<Subscription[]>([]);
  loading: boolean;
  avatars = signal<Avatar[]>([]);

  constructor(
    private windowService: WindowService,
  ) {
      const generateRandomName = () => {
        const characters = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz';
        const nameLength = Math.floor(Math.random() * 15) + 1;
        let name = '';
        for (let i = 0; i < nameLength; i++) {
          name += characters.charAt(Math.floor(Math.random() * characters.length));
        }
        return name;
      };

      const avatars: Avatar[] = [];
      for (let i = 0; i < 100; i++) {
        avatars.push({ id: i, imageUrl: `https://randomuser.me/api/portraits/women/${i}.jpg`, name: generateRandomName() });
        avatars.push({ id: i + 100, imageUrl: `https://randomuser.me/api/portraits/men/${i}.jpg`, name: generateRandomName() });
      }
      // Shuffle
      for (let i = avatars.length - 1; i > 0; i--) {
        const j = Math.floor(Math.random() * (i + 1));
        [avatars[i], avatars[j]] = [avatars[j], avatars[i]];
      }
      // End of Shuffle
      this.avatars.set(avatars);

    }

    trackById(index: number, avatar: Avatar): number {
      return avatar.id; // Optimize rendering with trackBy
    }
  
    onAvatarClick(avatar: Avatar): void {
      console.log(`Clicked avatar: ${avatar.name}`);
    }
    
    doAlert(message: string = 'Coming soon'): void {
      alert(message);
    }


  ngOnInit(): void {
    this.windowService.goToTop();
  }
  ngOnDestroy(): void {
    this.subscriptions().forEach(sub => sub.unsubscribe());
  }


}
